// assets/custom.js

/* ================================
 * 1) Quick Add: 加购成功气泡提示
 * ================================ */
document.addEventListener('DOMContentLoaded', () => {
  let bubble = document.getElementById('cart-bubble');
  if (!bubble) {
    bubble = document.createElement('div');
    bubble.id = 'cart-bubble';
    bubble.innerHTML = '✔';
    document.body.appendChild(bubble);
  }

  // 兼容主题里可能存在的 quick add 按钮
  document.querySelectorAll('form[action^="/cart/add"] [name="quick_add"]').forEach(btn => {
    btn.addEventListener('click', async e => {
      e.preventDefault();
      const form = e.currentTarget.closest('form');
      if (!form) return;

      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      });

      if (resp.ok) {
        bubble.classList.add('is-active');
        setTimeout(() => bubble.classList.remove('is-active'), 2000);
      } else {
        try {
          console.error('添加购物车失败', await resp.json());
        } catch (err) {
          console.error('添加购物车失败');
        }
      }
    });
  });
});


/* ================================
 * 2) Cart Expire (PC/手机通用)
 * 规则：最后一次“购物车更新”(add/change/remove/clear) 起算 1 小时
 *      超时则清空购物车
 * 浏览页面/滚动/点击都不算更新
 * ================================ */

;(() => {
  // ===== 配置 =====
  const EXPIRE_MINUTES = 60;                 // ✅ 1小时（你要改就改这里）
  const EXPIRE_MS = EXPIRE_MINUTES * 60 * 1000;

  // ✅ 默认不在 PWA 独立模式(店头平板常用)运行，避免与你的店头版本冲突
  // 如果你希望平板也跑这个规则：改成 false
  const SKIP_IN_STANDALONE = true;

  // 可选：只在特定路径启用（例如 "/pages/kiosk"），留空=全站启用
  const ONLY_ON_PATH_PREFIX = "";

  // 可选：排除某些路径（避免店头页面）
  const EXCLUDE_PATH_PREFIXES = []; // 例：["/pages/tablet", "/pages/kiosk"]

  // ===== 存储键 =====
  const KEY_TS   = "__cart_last_mutation_ts__"; // 最后一次购物车变更时间（毫秒）
  const KEY_SIG  = "__cart_sig__";              // 购物车签名（key+quantity）
  const KEY_FLAG = "__cart_expired_flag__";     // 可选：用于提示

  // 主题编辑器预览时不触发
  if (window.Shopify && Shopify.designMode) return;

  // 路径限制
  if (ONLY_ON_PATH_PREFIX && !location.pathname.startsWith(ONLY_ON_PATH_PREFIX)) return;
  if (EXCLUDE_PATH_PREFIXES.some(p => location.pathname.startsWith(p))) return;

  // 店头 PWA 独立模式跳过（避免和你店头版本冲突）
  if (SKIP_IN_STANDALONE) {
    const isStandalone =
      (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) ||
      (window.navigator && window.navigator.standalone);
    if (isStandalone) return;
  }

  // ===== 工具函数（安全读写 localStorage）=====
  const safeGet = (k) => {
    try { return localStorage.getItem(k); } catch (e) { return null; }
  };
  const safeSet = (k, v) => {
    try { localStorage.setItem(k, String(v)); } catch (e) {}
  };
  const safeDel = (k) => {
    try { localStorage.removeItem(k); } catch (e) {}
  };

  const now = () => Date.now();
  const getTs = () => Number(safeGet(KEY_TS) || 0) || 0;
  const setTs = (t) => safeSet(KEY_TS, t);

  const getSig = () => safeGet(KEY_SIG) || "";
  const setSig = (s) => safeSet(KEY_SIG, s);

  let timer = null;
  let syncing = false;
  let syncQueued = false;

  // 计算“购物车签名”：只关心 key+quantity（符合你定义的“更新”）
  const cartSig = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return "";
    return cart.items
      .map(it => `${it.key}:${it.quantity}`)
      .sort()
      .join("|");
  };

  async function fetchCart() {
    const res = await fetch("/cart.js", {
      method: "GET",
      headers: { "Accept": "application/json" },
      credentials: "same-origin",
      cache: "no-store"
    });
    if (!res.ok) throw new Error("cart.js fetch failed");
    return await res.json();
  }

  function schedule() {
    if (timer) clearTimeout(timer);
    const ts = getTs();
    if (!ts) return;

    const elapsed = now() - ts;
    const wait = EXPIRE_MS - elapsed;

    if (wait <= 0) {
      clearCart("timeout");
    } else {
      // 到点触发（稍微加一点余量）
      timer = setTimeout(() => clearCart("timeout"), wait + 200);
    }
  }

  async function syncCart(reason) {
    // 防止高频重复请求
    if (syncing) {
      syncQueued = true;
      return;
    }
    syncing = true;

    try {
      const cart = await fetchCart();
      const sig = cartSig(cart);
      const prevSig = getSig();

      if (!cart.item_count || cart.item_count <= 0) {
        // 购物车空：清理记录
        safeDel(KEY_TS);
        safeDel(KEY_SIG);
        schedule();
        return;
      }

      // 没有 ts：说明第一次记录 → 从现在开始计时
      if (!getTs()) setTs(now());

      // 签名变化：说明发生了“更新”（加/改数量/删）→ 重置计时
      if (sig && sig !== prevSig) {
        setTs(now());
        setSig(sig);
      } else if (!prevSig && sig) {
        setSig(sig);
      }

      schedule();
    } catch (e) {
      // 拉不到 cart.js 就不处理，避免影响正常购物
    } finally {
      syncing = false;
      if (syncQueued) {
        syncQueued = false;
        syncCart("queued");
      }
    }
  }

  async function clearCart(reason) {
    // 二次确认：如果中途更新过，就不清
    const ts = getTs();
    if (!ts) return;

    if (now() - ts < EXPIRE_MS) {
      schedule();
      return;
    }

    // 防止重复清空
    if (clearCart.__running) return;
    clearCart.__running = true;

    try {
      await fetch("/cart/clear.js", {
        method: "POST",
        headers: { "Accept": "application/json", "Content-Type": "application/json" },
        credentials: "same-origin"
      });
    } catch (e) {
      // 清空失败也继续清理本地记录，避免死循环
    } finally {
      safeDel(KEY_TS);
      safeDel(KEY_SIG);
      safeSet(KEY_FLAG, String(now())); // 可选：用于提示
      clearCart.__running = false;

      // 如果在 /cart 页面，刷新一下让界面立刻变空
      if (location.pathname.startsWith("/cart")) {
        location.reload();
      }
    }
  }

  // ===== 监听“购物车更新”（fetch / XHR）=====
  function isCartMutation(url, method) {
    if (!url) return false;
    const m = (method || "GET").toUpperCase();
    if (m === "GET") return false;
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  }

  // hook fetch
  const _fetch = window.fetch;
  if (typeof _fetch === "function") {
    window.fetch = function (input, init) {
      const url = typeof input === "string" ? input : (input && input.url) || "";
      const method = (init && init.method) || (input && input.method) || "GET";

      return _fetch.apply(this, arguments).then((res) => {
        if (res && res.ok && isCartMutation(url, method)) {
          // 发生变更：立刻重置计时 + 稍后同步签名
          setTs(now());
          setTimeout(() => syncCart("mutation"), 150);
          schedule();
        }
        return res;
      });
    };
  }

  // hook XHR（以防某些脚本不用 fetch）
  const _open = XMLHttpRequest.prototype.open;
  const _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__cartMethod = method;
    this.__cartUrl = url;
    return _open.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    this.addEventListener("load", () => {
      try {
        if (this.status >= 200 && this.status < 300 && isCartMutation(this.__cartUrl, this.__cartMethod)) {
          setTs(now());
          setTimeout(() => syncCart("xhr-mutation"), 150);
          schedule();
        }
      } catch (e) {}
    });

    return _send.apply(this, arguments);
  };

  // ===== “去结账”也算更新（点击那一刻刷新计时）=====
  // checkout 页面通常不加载主题脚本，所以这里只记录“点击去结账”
  document.addEventListener("click", (e) => {
    const a = e.target.closest && e.target.closest("a");
    if (a) {
      const href = a.getAttribute("href") || "";
      if (href.includes("/checkout")) {
        setTs(now());
        schedule();
      }
    }
  }, true);

  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (form && form.action && String(form.action).includes("/checkout")) {
      setTs(now());
      schedule();
    }
  }, true);

  // 多标签页同步：别的标签页更新了购物车，这边也要更新计时器
  window.addEventListener("storage", (ev) => {
    if (ev.key === KEY_TS || ev.key === KEY_SIG) schedule();
  });

  // ===== 初始化：永远同步一次（更稳，避免非Ajax加购漏记）=====
  syncCart("init");

  // （可选）提示“购物车已超时清空”
  // 如果要提示，把下面注释取消即可：
  /*
  const flag = safeGet(KEY_FLAG);
  if (flag) {
    safeDel(KEY_FLAG);
    alert("购物车已超过 1 小时未更新，已自动清空。");
  }
  */
})();
